import { render, staticRenderFns } from "./d3example.vue?vue&type=template&id=135fcd1e&scoped=true&"
import script from "./d3example.vue?vue&type=script&lang=js&"
export * from "./d3example.vue?vue&type=script&lang=js&"
import style0 from "./d3example.vue?vue&type=style&index=0&id=135fcd1e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "135fcd1e",
  null
  
)

export default component.exports